// Product descriptions for product-level comparisons
export const productDescriptions = {
    product_analytics: {
        name: 'Product analytics',
        description: 'Track events and conversion, analyze user behavior',
    },
    web_analytics: {
        name: 'Web analytics',
        description: 'Easy to use analytics for marketing websites',
    },
    session_replay: {
        name: 'Session replay',
        description: 'Watch real users use your product, diagnose bugs',
    },
    feature_flags: {
        name: 'Feature flags',
        description: 'Roll out features safely, toggle features for cohorts or individuals',
    },
    experiments: {
        name: 'Experiments',
        description: 'Run tests on new features, optimize conversion funnels',
    },
    surveys: {
        name: 'Surveys',
        description: 'Collect and analyze feedback, run NPS and PMF surveys',
    },
    error_tracking: {
        name: 'Error tracking',
        description: 'Track and monitor errors and exceptions in your code',
    },
    llm_analytics: {
        name: 'LLM analytics',
        description: 'Gather usage and performance data for your AI and LLM product',
    },
    revenue_analytics: {
        name: 'Marketing analytics',
        description: 'Track conversion and campaign ROI',
    },
    product_tours: {
        name: 'Product tours',
        description: 'Create guides for new users',
    },
    cdp: {
        name: 'CDP',
        description: 'Ingest, transform, and send data between 145+ tools',
    },
    data_warehouse: {
        name: 'Data warehouse',
        description: 'Sync and query data from your database',
    },
    dashboards: {
        name: 'Dashboards',
        description: 'Combine insights into shareable dashboards',
    },
}
